import { render, staticRenderFns } from "./ScheduledPublishEventsDialog.vue?vue&type=template&id=2ea2039a&scoped=true"
import script from "./ScheduledPublishEventsDialog.vue?vue&type=script&lang=js"
export * from "./ScheduledPublishEventsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea2039a",
  null
  
)

export default component.exports